import styled from 'styled-components'

export const AppTableContainer = styled.div`
  height: auto;
`
